const mobileBreakpoint = window.matchMedia('(max-width: 1023px)')

const closeSiblings = (item) => {
  const parent = item.parentElement

  if (!parent) {
    return
  }

  parent.querySelectorAll(':scope > .is-open').forEach((sibling) => {
    if (sibling !== item) {
      sibling.classList.remove('is-open')
    }
  })
}

const toggleItem = (item) => {
  const isOpen = item.classList.contains('is-open')

  closeSiblings(item)
  item.classList.toggle('is-open', !isOpen)
}

const handleLinkClick = (evt) => {
  if (!mobileBreakpoint.matches) {
    return
  }

  const link = evt.target.closest('.footer__head-link, .footer__sub-link')

  if (!link) {
    return
  }

  const item = link.closest('.footer__block--has-children, .footer__sub-item--has-children')

  if (!item || !item.contains(link)) {
    return
  }

  evt.preventDefault()
  toggleItem(item)
}

const resetDesktopState = () => {
  if (mobileBreakpoint.matches) {
    return
  }

  document.querySelectorAll('.footer__block.is-open, .footer__sub-item.is-open').forEach((item) => {
    item.classList.remove('is-open')
  })
}

export const initFooterMenu = () => {
  const footer = document.querySelector('.footer')

  if (!footer) {
    return
  }

  footer.addEventListener('click', handleLinkClick)

  if (typeof mobileBreakpoint.addEventListener === 'function') {
    mobileBreakpoint.addEventListener('change', resetDesktopState)
  } else if (typeof mobileBreakpoint.addListener === 'function') {
    mobileBreakpoint.addListener(resetDesktopState)
  }
}
